import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-mail-icon/jb-mail-icon.css.ts
var jb_mail_icon_css_default = i`:host{color:inherit;display:block;height:var(--icon-size, 18px);width:var(--icon-size, 18px)}svg{height:var(--icon-height, 18px);transition:var(--icon-transition, none);width:var(--icon-width, 18px)}`;

export {
  jb_mail_icon_css_default
};
